// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Tabs-module--bx--text-truncate--end--ocw7i";
export var bxTextTruncateFront = "Tabs-module--bx--text-truncate--front--XE9dz";
export var tabList = "Tabs-module--tab-list--GgZ5L";
export var dropdownWrapper = "Tabs-module--dropdownWrapper--WNX7e";
export var panel = "Tabs-module--panel--MVMfU";
export var tab = "Tabs-module--tab--JbgO1";